{
    "LockedOut": "Utilisateur verrouillé :",
    "PromptTos": "Conditions de service de Prompt :",
    "NotifyPasswordChange": "Notifier le changement de mot de passe :",
    "UpdateInterval": "Intervalle de mise à jour du rapport :",
    "UpdateIntervalCharacter": "s",
    "UpdateIntervalValidation": "L'intervalle de mise à jour du rapport est de 180 secondes au maximum",
    "MediaPlayer": "Désactiver les Plugin-Ins de Media Player :",
    "DragAndDrop": "Fonctions de glisser-déposer désactivées :",
    "JavascriptOutput": "Sortie d'audit JavaScript :",
    "AutoValue": "[Auto]",
    "SettingsLanguage_ServiceNotification": "Notification de service :",
    "SettingsLanguage_ConcurrentSignins": "Les enseignes simultanées sont autorisées :",
    "SettingsLanguage_AdvancedTitle": "Diagnostic avancé",
    "NAME": "SettingsLanguage",
    "SettingsLanguage_AuthNotifications": "Notification d'authentification :",
    "SettingsLanguage_NewDeviceNotifications": "Notifications d'approvisionnement :",
    "SettingsLanguage_AuthNotifications_Help": "L'activation des notifications d'authentification signifie que l'administrateur recevra un courriel lorsque l'autorisation d'un serveur de téléphonie MS Teams aura été obtenue.",
    "SettingsLanguage_NewDeviceNotifications_Help": "L'activation des notifications de provisionnement signifie que l'administrateur recevra un courriel lorsqu'un nouveau dispositif est ajouté ou que le mode d'intégration est modifié sur une instance de MS Teams."
}